import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';



function event_list() {
    if ($('[data-element="event_list_box"]').length) {
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        if (mediaQuery.matches) {
            function sameHeights () {
            var nodeList = document.querySelectorAll('[data-element="event_list_box"]');
            var elems = [].slice.call(nodeList);
            var tallest = Math.max.apply(Math, elems.map(function(elem, index) {
                elem.style.minHeight = ''; // clean first
                return elem.offsetHeight;
            }));
            elems.forEach(function(elem, index, arr){ 
                elem.style.minHeight = tallest + 'px';
            });
            
            }
            var resized = true;
            var timeout = null;
            var refresh = function(){
            if(resized) {
                requestAnimationFrame(sameHeights);
            }
                clearTimeout(timeout);
                timeout = setTimeout( refresh, 100);
            resized = false;
            };
            window.addEventListener('resize', function() { resized = true; });
            refresh();

        }

       
    }

    if ($('[data-element="event_list_box"]').length) {
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        if (mediaQuery.matches) {

        function sameHeights () {
        var nodeList = document.querySelectorAll('.event_cta');
        var elems = [].slice.call(nodeList);
        var tallest = Math.max.apply(Math, elems.map(function(elem, index) {
            elem.style.minHeight = ''; // clean first
            return elem.offsetHeight;
        }));
        elems.forEach(function(elem, index, arr){ 
            elem.style.minHeight = tallest + 'px';
        });
        
        }
        var resized = true;
        var timeout = null;
        var refresh = function(){
        if(resized) {
            requestAnimationFrame(sameHeights);
        }
            clearTimeout(timeout);
            timeout = setTimeout( refresh, 100);
        resized = false;
        };
        window.addEventListener('resize', function() { resized = true; });
        refresh();

    }
   
}

    
}

export default event_list;